import { lazy } from 'react';
import { retry } from '../../../config/utils';

const DasboardPartner = lazy(() => retry(()=> import(/* webpackChunkName: "PartnerUploadLoan" */ "./index")));

export default DasboardPartner;